// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom range slider styles */
.video-slider {
  appearance: none;
  background: transparent;
  cursor: pointer;
}

.video-slider::-webkit-slider-track {
  background: #4b5563;
  height: 8px;
  border-radius: 4px;
}

.video-slider::-webkit-slider-thumb {
  appearance: none;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #3b82f6;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.video-slider::-moz-range-track {
  background: #4b5563;
  height: 8px;
  border-radius: 4px;
  border: none;
}

.video-slider::-moz-range-thumb {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #3b82f6;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.video-slider:focus {
  outline: none;
}

.video-slider:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
}

.video-slider:focus::-moz-range-thumb {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/components/training/VideoPlayer.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EAEE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":["/* Custom range slider styles */\n.video-slider {\n  -webkit-appearance: none;\n  appearance: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.video-slider::-webkit-slider-track {\n  background: #4b5563;\n  height: 8px;\n  border-radius: 4px;\n}\n\n.video-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  background: #3b82f6;\n  cursor: pointer;\n  border: 2px solid #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.video-slider::-moz-range-track {\n  background: #4b5563;\n  height: 8px;\n  border-radius: 4px;\n  border: none;\n}\n\n.video-slider::-moz-range-thumb {\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  background: #3b82f6;\n  cursor: pointer;\n  border: 2px solid #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.video-slider:focus {\n  outline: none;\n}\n\n.video-slider:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);\n}\n\n.video-slider:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
